import * as React from "react"
import { List } from "immutable"
import { Jumbo } from "../components/jumbo"
import { Block, BlockRenderer } from "../components/block_renderer"
import { BasePageProps } from "../components/page_renderer"

export interface GeneralContentPageProps extends BasePageProps {
  readonly kind: "generalContent"
  readonly pageTitle: string
  readonly headerTitle: string
  readonly description: string
  readonly buttonUrl: string
  readonly buttonTitle: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly phImageUrlSmall?: string
  readonly phImageUrl: string
  readonly phImageUrlLarge: string
  readonly imageAlt: string
  readonly blocks: List<Block>
  readonly jumboSize: "small" | "large"
}

interface GeneralContentPageState {}

export class GeneralContentPage extends React.Component<GeneralContentPageProps, GeneralContentPageState> {
  componentDidMount() {
    document.title = this.props.pageTitle
  }

  render() {
    const p = this.props
    return (
      <div className='general-page'>
        <Jumbo
          title={p.headerTitle}
          contents={p.description}
          imageUrlSmall={p.jumboSize == 'small' && p.phImageUrlSmall ? p.phImageUrlSmall : undefined}
          imageUrl={p.phImageUrl}
          imageUrlLarge={p.phImageUrlLarge}
          imageAlt={p.imageAlt}
          buttonUrl={p.buttonUrl}
          buttonTitle={p.buttonTitle}
          size={p.jumboSize}
        />
        <div className={"general-page__content"}>
          <BlockRenderer blocks={p.blocks} />
        </div>
      </div>
    )
  }
}

{/* TH: Added to styleguide! */}
